
class HeaderNavigationComponent {
	constructor() {
		
	}
	
	toggle() {
		
	}
	
	show() {
		
	}
	
	hide() {
		
	}
	
	
}